// 固件列表查询
const QueryForm = {
    labelCol: { style: { width: '100px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        {
            // name:'标题',
            key:'notice_title',
            type:'input',
            allowClear:true,
            width:'220px',
            placeholder_lang:'按标题查询',
        },
        {
            // name:'平台',
            key:'status',
            type:'select',
            allowClear:true,
            width:'220px',
            placeholder_lang:'按状态查询',
            options:[
                {
                    label:'正常',
                    value:'0',
                },
                {
                    label:'取消',
                    value:'1',
                },
            ]
        },
    ]
}

QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
    if(item.key == 'status'){
        QueryForm.formData[item.key] = null
    }
})

export {
    QueryForm,
}